import axios from 'axios';

import {
    successGetAllClients,
    failedGetAllClients,
    successCreateClient,
    failedCreateClient,
    successGetClient,
    failedGetClient,
    successUpdateClient,
    failedUpdateClient,
    successGetClientFPs,    // Client + FP
    failedGetClientFPs,     //  "
    successSaveClientFPs,   //  "
    failedSaveClientFPs,    // Client + FP
    successGetSubClients,
    failedGetSubClients,
    successUpdateSubClient,
    failedUpdateSubClient,
} from '../actions/clientActions';
import { API_HOST, HTTP_PROTOCOL } from '../../config';

export const getAllClients = () => {
    const token = localStorage.getItem('token');
    const options = {
        method: 'get',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'JWT ' + token },
        url: `${HTTP_PROTOCOL}://${API_HOST}/clients/`,
    };
    
    return dispatch =>
        axios(options)
            .then(({ data }) => dispatch(successGetAllClients(data)))
            .catch((error) => dispatch(failedGetAllClients(error)));
};

export const updateClient = (client) => {
    const token = localStorage.getItem('token');
    const options = {
        method: 'put',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'JWT ' + token },
        url: `${HTTP_PROTOCOL}://${API_HOST}/clients/${client.pk_id_dme_client}/`,
        data: client,
    };
    return dispatch =>
        axios(options)
            .then(({ data }) => dispatch(successUpdateClient(data)))
            .catch((error) => dispatch(failedUpdateClient(error)));
};

export const createClient = (client) => {
    const token = localStorage.getItem('token');
    const options = {
        method: 'post',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'JWT ' + token },
        url: `${HTTP_PROTOCOL}://${API_HOST}/clients/`,
        data: client
    };
    return dispatch =>
        axios(options)
            .then(({ data }) => dispatch(successCreateClient(data)))
            .catch((error) => dispatch(failedCreateClient(error)));
};


export const getClient = (id) => {
    const token = localStorage.getItem('token');
    const options = {
        method: 'get',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'JWT ' + token },
        url: `${HTTP_PROTOCOL}://${API_HOST}/clients/${id}/`,
    };
    return dispatch =>
        axios(options)
            .then(({ data }) => dispatch(successGetClient(data)))
            .catch((error) => dispatch(failedGetClient(error)));
};

export const getClientFPs = (client, fp) => {
    const token = localStorage.getItem('token');
    const options = {
        method: 'get',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'JWT ' + token },
        url: `${HTTP_PROTOCOL}://${API_HOST}/clients/get_client_fps?fp=${fp ? fp.id : null}&client=${client ? client.pk_id_dme_client : null}`,
    };
    return dispatch =>
        axios(options)
            .then(({ data }) => dispatch(successGetClientFPs(data)))
            .catch((error) => dispatch(failedGetClientFPs(error)));
};

export const saveClientFPs = (clientFPs) => {
    const token = localStorage.getItem('token');
    const options = {
        method: 'post',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'JWT ' + token },
        url: `${HTTP_PROTOCOL}://${API_HOST}/clients/save_client_fps/`,
        data: { clientFPs }
    };
    return dispatch =>
        axios(options)
            .then(({ data }) => dispatch(successSaveClientFPs(data)))
            .catch((error) => dispatch(failedSaveClientFPs(error)));
};

export const getSubClients = () => {
    const token = localStorage.getItem('token');
    const options = {
        method: 'get',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'JWT ' + token },
        url: `${HTTP_PROTOCOL}://${API_HOST}/clients/get_sub_clients/`,
    };

    return dispatch =>
        axios(options)
            .then(({ data }) => dispatch(successGetSubClients(data)))
            .catch((error) => dispatch(failedGetSubClients(error)));
};

export const updateSubClient = (subClient) => {
    const token = localStorage.getItem('token');
    const options = {
        method: 'post',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'JWT ' + token },
        url: `${HTTP_PROTOCOL}://${API_HOST}/clients/update_sub_client/`,
        data: { ...subClient }
    };

    return dispatch =>
        axios(options)
            .then(({ data }) => dispatch(successUpdateSubClient(data)))
            .catch((error) => dispatch(failedUpdateSubClient(error)));
};



// WEBPACK FOOTER //
// ./src/state/services/clientService.js